import React from "react";
import { cn } from "./cn";

interface CardProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  /** Ícone à esquerda do título, num quadrado com a cor da marca. */
  icon?: React.ReactNode;
  /** Para atalhos (#id); a rolagem para abaixo do cabeçalho fixo. */
  id?: string;
  /** "none" para conteúdo que encosta na borda (lista, tabela). */
  padding?: "none" | "md";
  className?: string;
  children?: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({ title, description, actions, icon, id, padding = "md", className, children }) => {
  const hasHeader = Boolean(title || actions);
  return (
    <section
      id={id}
      className={cn(
        "flex min-w-0 scroll-mt-anchor flex-col gap-3.5 rounded-card border border-line bg-surface shadow-card",
        padding === "md" && "p-card",
        className
      )}
    >
      {hasHeader && (
        <header className={cn("flex flex-wrap items-center gap-3", padding === "none" && "px-card pt-card")}>
          {icon && (
            <span className="grid h-card-icon w-card-icon shrink-0 place-items-center rounded-control bg-primary-soft text-primary" aria-hidden>
              {icon}
            </span>
          )}
          <div className="min-w-0 flex-1">
            {title && <h2 className="text-heading font-semibold text-fg">{title}</h2>}
            {description && <p className="text-caption text-fg-muted">{description}</p>}
          </div>
          {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
        </header>
      )}
      {children}
    </section>
  );
};
